import type { AnalysisResult } from '../../api/dashboards';
import { DataTable, type Column } from '../ui';
import { formatCell } from './format';

type Row = AnalysisResult['rows'][number];

/**
 * A result as a table.
 *
 * Every chart ships with one of these: a Plotly figure is a picture to a screen
 * reader, so the table is the accessible view of the same numbers, not a
 * consolation prize.
 */
export function ResultTable({ result, caption }: { result: AnalysisResult; caption: string }) {
  const columns: Column<Row>[] = result.columns.map((column) => ({
    key: column.name,
    header: column.label,
    numeric: column.role === 'metric' || column.type === 'integer' || column.type === 'float',
    render: (row) => formatCell(row[column.name], column.type),
  }));

  return (
    <DataTable
      caption={caption}
      columns={columns}
      rows={result.rows}
      rowKey={(_, index) => String(index)}
      empty={<p className="sc-block__empty">No rows matched.</p>}
    />
  );
}
